import { render } from "./GeneralAcceptDialog.vue?vue&type=template&id=1e455478&scoped=true"
import script from "./GeneralAcceptDialog.vue?vue&type=script&lang=js"
export * from "./GeneralAcceptDialog.vue?vue&type=script&lang=js"

import "./GeneralAcceptDialog.vue?vue&type=style&index=0&id=1e455478&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e455478"]])

export default __exports__